export default __webpack_public_path__ + "static/media/CC_logo.8d7b55cb.jpg";